// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引用element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import './element-variables.scss'

// 多语言
import i18n from './i18n/i18n'

// 字体 公共样式 图标
import '../static/common-css/common.css'

// highlight.js代码高亮插件
import Highlight from './common/highlight';
import HtmlUtil from './common/HtmlUtil'
Vue.prototype.HtmlUtil = HtmlUtil
Vue.use(Highlight);
import directive from './public/directive'

// import mutual from './public/parentMutual'
import utils from './public/common'
import filters from './public/filters'
import 'animate.css'

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(vueSwiper)
//=========单页面触发百度统计代码===============
router.afterEach( ( to, from, next ) => {
  setTimeout(()=>{
    var _hmt = _hmt || [];
    (function() {
      //每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?878216b0b50da4f2acccb8589ada597a";
      hm.id = "baidu_tj"
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  },0);
} );
// Vue.prototype.mutual = mutual // 与父级交互
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.utils = utils

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  filters,
  directive,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js